var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_profile-2user",
    "data-name": "vuesax/outline/profile-2user",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H30V30H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M6.688,12.963h-.1a.678.678,0,0,0-.225,0,6.431,6.431,0,1,1,.363,0Zm-.2-11.088a4.608,4.608,0,0,0-.175,9.213,2.081,2.081,0,0,1,.4,0,4.609,4.609,0,0,0-.225-9.213Z",
    transform: "translate(4.762 1.562)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.205,10.625a.346.346,0,0,1-.113-.013A.99.99,0,0,1,.005,9.788.911.911,0,0,1,.78,8.75c.15-.012.312-.012.45-.012a3.44,3.44,0,0,0-.187-6.875A.926.926,0,0,1,.105.938.944.944,0,0,1,1.043,0,5.324,5.324,0,0,1,6.355,5.313a5.3,5.3,0,0,1-5.113,5.313Z",
    transform: "translate(19.469 4.063)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M9.463,12.641a12.347,12.347,0,0,1-6.775-1.875A5.364,5.364,0,0,1,0,6.328,5.42,5.42,0,0,1,2.688,1.866a13.234,13.234,0,0,1,13.55,0A5.393,5.393,0,0,1,18.925,6.3a5.42,5.42,0,0,1-2.687,4.463A12.377,12.377,0,0,1,9.463,12.641Zm-5.738-9.2a3.6,3.6,0,0,0-1.85,2.9,3.586,3.586,0,0,0,1.85,2.875,11.3,11.3,0,0,0,11.475,0,3.6,3.6,0,0,0,1.85-2.9A3.586,3.586,0,0,0,15.2,3.441,11.354,11.354,0,0,0,3.725,3.441Z",
    transform: "translate(2 15.547)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.931,9.385a.923.923,0,0,1-.912-.75A.95.95,0,0,1,.743,7.522,5.063,5.063,0,0,0,2.818,6.61a2.445,2.445,0,0,0,1.1-1.925A2.425,2.425,0,0,0,2.831,2.772,5.234,5.234,0,0,0,.781,1.86.942.942,0,0,1,1.193.022a6.976,6.976,0,0,1,2.775,1.25A4.3,4.3,0,0,1,5.793,4.685,4.354,4.354,0,0,1,3.956,8.11,6.77,6.77,0,0,1,1.131,9.36.585.585,0,0,1,.931,9.385Z",
    transform: "translate(21.994 16.553)",
    fill: "#292d32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1);
export default __webpack_public_path__ + "static/media/user1.fa4852bfef2e8782bd44c123a6adfab8.svg";
export { ForwardRef as ReactComponent };